import { faChartPie } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { CreatePollForm } from '~/components/forms/PollForm';
import { Heading } from '~/components/molecules/Heading';
import { useNavigate } from '~/components/utils/Navigation';
import { Breadcrumbs } from '../molecules/Breadcrumbs';
import { AppBreadcrumbs } from '../organisms/Breadcrumbs';

export type IAppCreatePollPageProps = {
  appId: string;
};

export const AppCreatePollPage: React.FC<IAppCreatePollPageProps> = (props) => {
  const { appId } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();

  const parentUrl = `/apps/${appId}/polls`;

  return (
    <>
      <Helmet>
        <title>{t('AppCreatePollPage.seo.title')}</title>
      </Helmet>

      <AppBreadcrumbs appId={appId}>
        <Breadcrumbs.Action href={parentUrl}>
          <FontAwesomeIcon icon={faChartPie} />
          {t('AppPollsPage.title')}
        </Breadcrumbs.Action>
      </AppBreadcrumbs>

      <Heading title={t('AppCreatePollPage.title')} previousUrl={parentUrl} />

      <CreatePollForm
        appId={appId}
        onSuccess={() => navigate(parentUrl)}
        cancelUrl={parentUrl}
      />
    </>
  );
};
